module.exports = __webpack_public_path__ + "static/media/icon_info_1.9d19d2f3.svg";